<span class="client-name">
  <span>{{ client | clientFullName }}</span>
  @if (client?.id) {
    @let state = state$ | async;
    <span class="client-name__presence client-name__presence--{{ state }}"
          [matTooltip]="'clients.livePresence.' + state | translate"
          matTooltipPosition="below">{{ 'clients.livePresence.short.' + state | translate }}</span>
  }
</span>
